
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'

import {
  Container as BaseContainer,
  Image as BaseImage,
} from 'components/base/Form/InsuranceTypeRadio/styles'

export const Container = styled(BaseContainer)`
  position: relative;
  cursor: default;
  span {
    cursor: default;
  }
  &:after {
    background: #fff;
    color: ${COLORS.GREYDARK};
    content: 'Coming Soon';
    text-align: center;
    padding: 10px 0;
    font-size: ${FONTS.PARAGRAPHSMALL};
    position: absolute;
    width: 100%;
    top: 50%;
    font-style: italic;
  }
`

export const Image = styled(BaseImage)`
  opacity: .5;
  cursor: default;
  visibility: visible;
  margin-top: 30px !important;
`
